import Vue from 'vue';
import VMap from '@/components/VMap.vue'
import { encode, decode } from 'js-base64'

export const $eventBus = new Vue();

export const $localStorage = {
	get centerId() {
		return decode(JSON.parse(localStorage.getItem('centerId')) || '');
	},
	set centerId(newVal) {
		if (newVal === null) localStorage.removeItem('centerId');
		else localStorage.setItem('centerId', JSON.stringify(encode(newVal)));
	},

	get username() {
		return decode(JSON.parse(localStorage.getItem('username')) || '');
	},
	set username(newVal) {
		if (newVal === null) localStorage.removeItem('username');
		else localStorage.setItem('username', JSON.stringify(encode(newVal)));
	},

	get password() {
		return decode(JSON.parse(localStorage.getItem('password')) || '');
	},
	set password(newVal) {
		if (newVal === null) localStorage.removeItem('password');
		else localStorage.setItem('password', JSON.stringify(encode(newVal)));
	},
}
export const edunix = {
	install: (Vue, options) => {
		// global variable
		Vue.prototype.$eventBus = $eventBus;
		Vue.prototype.$localStorage = Vue.observable($localStorage);

		// components
		Vue.component('VMap', VMap);
	}
}

Vue.use(edunix);

export default {}